<template>
  <div class="flex flex-col">
    <p class="text-base lg:text-lg px-2 lg:px-3 lg:py-1 text-gray-600 font-medium border-l-4 lg:border-l-8 border-theme-secondary mb-3 lg:mb-6">Contact Information</p>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-4">
      <TextControl :maxLength="20" ref="telephone_no" is_num label="Telephone Number" fieldId="telephone_no" :required="false" v-model="form.telephone_no" />
      <TextControl :maxLength="35" ref="social_media" label="Other Social Media Account" fieldId="social_media" v-model="form.social_media"/>
      <TextControl :maxLength="10" ref="mobile_no" is_num label="Mobile Number" fieldId="mobile_no" :required="true" v-model="form.mobile_no"  is_phone/>
      <TextControl :maxLength="50" ref="email" is_email label="Email Address" fieldId="email" :required="true" v-model="form.email"/>
    </div>

    <p class="text-base lg:text-lg px-2 lg:px-3 lg:py-1 text-gray-600 font-medium border-l-4 lg:border-l-8 border-theme-secondary mb-3 lg:mb-6 mt-6 lg:mt-12">Employment Information</p>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-4">
        <ComboBoxControl label="Employment Status" fieldId="emp_type" v-model="form.emp_type" required :options="employOptions"/>
        <TextControl :maxLength="20" ref="emp_type_others" label="Others (please specify)" fieldId="emp_type_others" v-model="form.emp_type_others"/>
        <TextControl :maxLength="20" ref="emp_name" label="Employer/Business Name" fieldId="emp_name" required v-model="form.emp_name"/>
        <ComboBoxControl label="Nature of Work" fieldId="nature_of_work" v-model="form.nature_of_work" required :options="natureOptions"/>
        <TextControl :maxLength="20" ref="work_oth" label="Other Work/Profession" fieldId="work_oth" v-model="form.work_oth"/>
        <TextControl :maxLength="10" ref="emp_no" label="House No." fieldId="emp_no" v-model="form.emp_no"/>
        <TextControl :maxLength="30" ref="emp_street" label="Street" fieldId="emp_street"  v-model="form.emp_street"/>
        <TextControl :maxLength="30" ref="emp_brgy" label="Brgy, Subdivision" fieldId="emp_brgy"  v-model="form.emp_brgy"/>
        <ComboBoxControl label="Country" fieldId="emp_country" v-model="form.emp_country" :options="countryOptions"/>

        <template v-if="isPhilippines">
          <ComboBoxControl label="Province" fieldId="emp_province" v-model="form.emp_province" :options="provinceOptions" :disabled="!form.emp_country"/>
          <ComboBoxControl label="Municipality" fieldId="emp_municipality" v-model="form.emp_municipality" :options="cityOptions" :is-loading="cityLoading" :disabled="!form.emp_province"/>
        </template>

        <template v-else>
          <TextControl :max-length="40" label="Province" fieldId="emp_province" v-model="form.emp_province" />
          <TextControl :max-length="40" label="Municipality" fieldId="emp_municipality" v-model="form.emp_municipality" />
        </template>

        <TextControl :maxLength="10" ref="emp_zipcode" label="ZIP Code" fieldId="emp_zipcode" v-model="form.emp_zipcode" is_zip is_num/>
        <TextControl :maxLength="50" ref="emp_email" is_email label="Employer's Email Address" fieldId="emp_email" v-model="form.emp_email" />
      </div>

      <div class="mt-8 xl:mt-16 flex flex-row gap-2 lg:gap-4">
            <ButtonControl theme="bg-white border-2 border-theme-primary text-theme-primary" rounded button_text="Back" @click="$emit('back')"/>
            <ButtonControl theme="bg-primary border-2 border-theme-primary text-white" rounded button_text="Next" @click="$emit('next')" :disabled="!isFormComplete"/>
      </div>

  </div>
</template>

<script>
import TextControl from '@/components/controls/TextControl.vue';
import ComboBoxControl from '@/components/controls/ComboBoxControl.vue';
import ButtonControl from '@/components/controls/ButtonControl.vue';

import User from '@/services/User';
import mixin from '@/mixin';

export default {
  name: 'v-tab-2',
  inject: ['setLoading'],
  mixins: [mixin],
  data() {
    return {
      validationErrors: {},
      cityOptions: [],
      cityLoading: false,
      form: {
        telephone_no: '',
        social_media: '',
        mobile_no: '',
        email: '',
        emp_type: '',
        emp_type_others: '',
        emp_name: '',
        nature_of_work: '',
        work_oth: '',
        emp_no: '',
        emp_street: '',
        emp_brgy: '',
        emp_province: '',
        emp_municipality: '',
        emp_country: '',
        emp_zipcode: '',
        emp_email: '',
      },
    };
  },
  mounted() {
    this.restoreFormFromStore();
    this.autoFillFromCredentials();
    this.$store.commit('setFormDataPNB', this.form);
  },
  components: {
    TextControl,
    ComboBoxControl,
    ButtonControl
  },
  computed: {
    isFormComplete() {
        return (
          this.form.mobile_no &&
          this.form.email &&
          
          this.form.emp_type &&
          this.form.emp_name &&
          this.form.nature_of_work
        );
    },
    isPhilippines() {
      return this.form.emp_country === 'PHILIPPINES';
    },
    employOptions() {
      const lookup = this.$store.state.lookup;
      if (!lookup || !lookup.employment_status) return [];

      return lookup.employment_status.map(g => ({
        label: g.value,
        value: g.key
      }));
    },
    natureOptions() {
      const nature = this.$store.state.lookup?.nature_of_work_pnb;

      if (!Array.isArray(nature)) return [];

      return nature.map(item => ({
        label: item,
        value: item
      }));
    },
    countryOptions() {
      const lookup = this.$store.state.lookup;
      if (!lookup || !lookup.country) return [];

      return lookup.country.map(c => ({
        label: c,
        value: c
      }));
    },
    provinceOptions() {
      const provinces = this.$store.state.provinces;

      if (!Array.isArray(provinces)) return [];

      return provinces.map(p => ({
        label: p.province_name,
        value: p.province_code
      }));
    },
  },
  watch: {
    form: {
      deep: true,
      handler(newValue) {
        this.$store.commit('setFormDataPNB', newValue);
      },
    },
    'form.emp_province'(newProvince) {
      if (newProvince) {
        this.cityLoading = true;
        this.form.emp_municipality = "";

        if (this.form.emp_country == 'PHILIPPINES') {
          User.getCity(newProvince)
            .then((response) => {
              console.log('Cities fetched:', response.data.data);
              this.cityOptions = response.data.data.map(city => ({
                label: city.city_name,
                value: city.fcity_code
              }));
              this.cityLoading = false;
            })
            .catch((error) => {
              console.error('Error fetching cities:', error);
              this.cityLoading = false;
            });
        }

      }
    },
    'form.emp_country'() {
      this.form.emp_province = "";
      this.form.emp_municipality = "";
      this.form.emp_brgy = "";

      this.cityOptions = [];
    },
  },
  methods: {
    normalizePhone(value) {
      if (!value) return "";

      const digits = String(value).replace(/\D/g, '');
      if (digits.startsWith('+63')) return digits.slice(3);
      if (digits.startsWith('63')) return digits.slice(2);
      if (digits.startsWith('0')) return digits.slice(1);
      return digits;
    },
    restoreFormFromStore() {
    const storeFormData = this.$store.state.formDataPNB || {};

    Object.keys(this.form).forEach((key) => {
      if (
        Object.prototype.hasOwnProperty.call(storeFormData, key) &&
        storeFormData[key] !== undefined &&
        storeFormData[key] !== null
      ) {
        this.form[key] = storeFormData[key];
      }
    });
  },

  autoFillFromCredentials() {
    const credentials = this.$store.state.credentials || {};

    // Normal fields
    const mappings = {
      email: "email",
    };

    Object.entries(mappings).forEach(([formField, credentialField]) => {
      if (!this.form[formField] && credentials[credentialField] != null) {
        this.form[formField] = credentials[credentialField];
      }
    });

    // Phone number with formatting
    if (!this.form.mobile_no && credentials.mobile) {
      this.form.mobile_no = this.normalizePhone(credentials.mobile);
    }
  },

  updateValidation(field, isValid) {
    this.validationErrors[field] = isValid;
  },
  },
};
</script>

<style scoped>
.papsi-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 2rem;
}
.box {
  width: 4rem !important;
  height: 4rem !important;
  margin-right: 3rem !important; 
}
@media (max-width: 1000px) {
    .box {
      width: 2rem !important;
      height: 2rem !important;
      margin-right: 1rem !important;
      font-size:  5rem !important;
    }
    .agree {
      font-size: 1.7rem !important; 
    }
   

}

</style>